import { render } from "./HonoreeFormTextAreaField.vue?vue&type=template&id=50db76a8"
import script from "./HonoreeFormTextAreaField.vue?vue&type=script&lang=js"
export * from "./HonoreeFormTextAreaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__